module.exports = function() {
  return new Worker(__webpack_public_path__ + "5d3da76d0fe9925ec1b6.worker.js");
};